import Axios from 'axios';
import axios from "./axios";
export const getEmailImageUploadingURL = body => axios.post('/mailing/v1/media', body);
export const uploadMedia = (url, file) => Axios.put(url, file);